import React from "react";
import { withNamespaces } from "react-i18next";

const NewCheckoutLoader = ({ t, isVisible, children }) => {
  return(
    <div className={isVisible ? 'loader is-visible' : 'loader'}>
      <figure>
        <img src="/logo--loader.gif" alt="loader"/>
        {children ? (
          children
        ) : (
            <p className="checkout-loader-wait-text">
            { t('Hang tight.') }
            <br/>
            { t('This may take a minute or two...') }
          </p>
        )}
      </figure>
    </div>
  )
}

export default withNamespaces()(NewCheckoutLoader);
